<template>
  <b-card no-body>
    <b-card-body>
      <detail-roles-and-permissions
        ref="rolesAndPermissions"
        type="edit"
        :submitting="submitting"
        :values="data"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import useService from '@/auth/service/useService';
import detailRolesAndPermissions from '@/views/pages/roles/DetailRole.vue';

export default {
  components: {
    BCard,
    BCardBody,
    detailRolesAndPermissions
  },

  mixins: [helper],

  data() {
    return {
      submitting: false,
      id: '',
      data: {}
    };
  },

  created() {
    const { id } = this.$route.params;
    this.id = id;
    this.editRoles(id);
  },

  methods: {
    submit(data) {
      this.submitting = true;
      useService
        .updateRole(this.id, data)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
          this.$router.push({ name: 'roles' });
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    editRoles(roleId) {
      this.submitting = true;
      useService
        .getRole(roleId)
        .then(response => {
          this.data = response.data;

          const { id, name, title, description, status } = response.data;

          this.data = {
            id,
            title,
            name,
            description,
            status
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
